import parsePhoneNumberFromString from "libphonenumber-js";
import { ReplaceEmployeeFormValuesType } from "../../pages/employees/EmployeeDetails/TabContentPages/EmployeePersonalDetails";
import { Employee } from "../../models";

export const updateUser = async (
    API_URL: string,
    token: string,
    employerId: string,
    employee: Employee,
    values: ReplaceEmployeeFormValuesType,
    countryId: any
) => {
    if (
        !values.contact.address?.address1?.length &&
        employee.contact.address?.address1
    ) {
        throw new Error("Cannot remove address from employee");
    }

    if (!values.contact.phone?.length && employee.contact?.phone) {
        throw new Error("Cannot remove phone from employee");
    }

    let formattedPhoneNumber = null;
    if (values.contact.phone?.length) {
        formattedPhoneNumber = parsePhoneNumberFromString(
        values.contact.phone,
        countryId
        )?.number;
    }

    const response = await fetch(
        `${API_URL}/employers/${employerId}/employees/${employee.id}`,
        {
        method: "PUT",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            customerEmployeeId: values.customerEmployeeId,
            firstName: values.firstName,
            lastName: values.lastName,
            cardDisplayName: values.cardDisplayName,
            contact: {
            email: values.contact.email,
            phone: formattedPhoneNumber,
            address: {
                ...values.contact.address,
                city: values.contact.address.city,
                // Only include state/province for outside of NZ
                stateOrProvince:
                countryId !== "NZ"
                    ? values.contact.address.stateOrProvince
                    : undefined,
                country: countryId ?? ""
            }
            }
        })
        }
    );

    if (!response.ok) {
        const responseJson = await response.json();

        switch (response.status) {
        case 400:
            if (responseJson.errors["Contact.Phone"]) {
            throw new Error(responseJson.errors["Contact.Phone"][0]);
            } else if (responseJson.errors["Contact.Email"]) {
            throw new Error(responseJson.errors["Contact.Email"][0]);
            } else {
            throw new Error("There was a problem updating this user");
            }
        default:
            throw new Error("There was a problem updating this user");
        }
    }
}
